'use strict';
(function () {
  angular.module('pentaApp').factory('publicKey.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/publicKey');
  }
})();
